import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { PageBackground } from "@/components/PageBackground";

export default function SsoLogin() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      toast.error("Missing SSO token");
      navigate("/auth");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/wordpress/sso", { token });
        loginWithToken(data.token, data.user);
        toast.success(`Welcome, ${data.user.name}`);
        navigate(data.user.role === "tenant" ? "/tenant" : data.user.role === "landlord" ? "/landlord" : "/admin");
      } catch (e) {
        toast.error(e.response?.data?.detail || "SSO sign-in failed");
        navigate("/auth");
      }
    })();
  }, [params, navigate, loginWithToken]);

  return (
    <div className="min-h-screen grid place-items-center text-muted-foreground">
      <PageBackground variant={1} />
      <div className="text-center">
        <Loader2 className="w-8 h-8 mx-auto mb-3 animate-spin text-primary" />
        Signing you in from MyRentalMatch.com…
      </div>
    </div>
  );
}
